import React from 'react';
import { Input } from '../../../../../shared/ui/input';
import { Label } from '../../../../../shared/ui/label';
import { acceptNumericDraft } from '../../../../../shared/utils/numericInput';
import { getDealRevenue } from '../../../../../shared/utils/dealRevenue';

export default function DealValueFields({ deal, amountField, onFieldChange, idPrefix = '', compact = false, disabled = false }) {
  const revenue = getDealRevenue(deal).toLocaleString('it-IT', { style: 'currency', currency: 'EUR' });
  return <div className="deal-form-dialog__grid">
    <div className="deal-form-dialog__field">
      <Label htmlFor={`${idPrefix}${amountField}`}>{compact ? 'Valore affare' : 'Valore dell’affare'}</Label>
      <div className={compact ? 'deal-create-form__input-unit deal-create-form__input-unit--leading' : undefined}>
        {compact ? <span aria-hidden="true">€</span> : null}
        <Input id={`${idPrefix}${amountField}`} inputMode="decimal" value={deal[amountField] ?? ''} disabled={disabled}
          onChange={(event) => acceptNumericDraft(event, (value) => onFieldChange(amountField, value), { min: 0 })}
          placeholder={compact ? '0,00' : 'EUR 0,00'} />
      </div>
    </div>
    <div className="deal-form-dialog__field">
      <Label htmlFor={`${idPrefix}probability`}>{compact ? 'Commissione' : 'Percentuale (%)'}</Label>
      <div className={compact ? 'deal-create-form__input-unit' : undefined}>
        <Input id={`${idPrefix}probability`} inputMode="decimal" value={deal.probability ?? ''} disabled={disabled}
          aria-describedby={`${idPrefix}percentage-help`}
          onChange={(event) => acceptNumericDraft(event, (value) => onFieldChange('probability', value), { min: 0, max: 100 })}
          placeholder={compact ? 'Es. 3,5' : '100'} />
        {compact ? <span aria-hidden="true">%</span> : null}
      </div>
      {!compact ? <small id={`${idPrefix}percentage-help`}>Quota incassata dall’azienda. Se vuota, si applica il 100%.</small> : null}
    </div>
    {compact ? <div className="deal-create-form__revenue">
      <small id={`${idPrefix}percentage-help`}>Percentuale incassata dall’azienda. Se vuota, si applica il 100%.</small>
      <p>Incasso aziendale previsto: <output id={`${idPrefix}company-revenue`} htmlFor={`${idPrefix}${amountField} ${idPrefix}probability`} aria-live="polite">{revenue}</output></p>
    </div> : <div className="deal-form-dialog__field">
      <Label htmlFor={`${idPrefix}company-revenue`}>Incasso aziendale previsto</Label>
      <Input id={`${idPrefix}company-revenue`} readOnly value={revenue} />
    </div>}
  </div>;
}
